import React from "react";
import { IconType, JWayIcon } from "../../../assets/JWayIcons";
import styles from "./SectionTitle.module.scss";
export interface SectionTitleProps {
  children: React.ReactNode;
  iconType?: IconType;
  color?: string;
  iconSize?: number;
  stickyMode?: boolean;
  titleRender?: () => React.JSX.Element;
}

/**
 * Section title component
 * @param param0
 * @returns
 */
export default function SectionTitle({
  children,
  iconType,
  color = "#858585",
  iconSize = 15,
  stickyMode,
  titleRender

}: SectionTitleProps) {
  return (
    <div className={styles["container--global"]}>
    <div
      style={{
        color: color,
      }}
      className={[styles["container-title"], styles["container-title--sticky"]].join(" ")}
    >
      {iconType && (
        <div className={[styles["container-title__icon"]].join(" ")}>
          <JWayIcon type={iconType} size={iconSize} color={color} />
        </div>
      )}
      <h2 className={[styles["container-title__title"]].join(" ")}>
        {titleRender && titleRender()} {children}

      </h2>
    </div>
   
    </div>
  );
}

export const Section = ({children, stickyHeaderRender, zIndex = 10, topGap = 100} : {children?: React.ReactNode, stickyHeaderRender?: () => React.JSX.Element, zIndex?: number, topGap?: number}) => {
  return (
    <section className={styles["section-sticky-zone"]}>
      <div  className={styles["section-sticky-zone__header"]} style={{zIndex: zIndex, top: topGap}}>
        {stickyHeaderRender && stickyHeaderRender()}
      </div>
      {children}
    </section>
  )
}
